export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[640px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            欢迎漫画作者投稿、商务合作洽谈或反馈意见建议，香蕉漫画期待与更多漫画创作者和平台携手合作
          </p>

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3 justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">投稿与合作邮箱</div>
                  <div className="text-sm font-medium text-foreground-800">contact@banana-comics.com</div>
                </div>
              </div>

              <div className="flex items-center gap-3 justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-800">香蕉漫画推荐</div>
                </div>
              </div>

              <div className="flex items-center gap-3 justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-shake-hands-line text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">商务合作</div>
                  <div className="text-sm font-medium text-foreground-800">bd@banana-comics.com</div>
                </div>
              </div>
            </div>

            <p className="text-xs text-foreground-500 mt-6 leading-relaxed">
              我们通常在工作日 24 小时内回复。漫画作者投稿请附上作品简介和样章，商务合作请说明合作意向。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}